import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import closeIcon from 'assets/Images/close.svg'
import plusBlue from 'assets/Images/plusBlue.svg'
import { creationClassStore } from 'state/class/classCreationStore'
import { myStore } from 'state/roleStore'
import EmptyData from 'components/global/EmptyData'
import {
  AddEmailTemplatesIntoTheClassPayload,
} from 'types/Classes/EmailTemplates'
import TemplateInfo from './TemplateInfo'
import EmailTemplateModal from 'pages/Events/Views/Common/Modals/EmailTemplateModal'
import { useCreateEmailTemplateForClass, useEditEmailTemplateForClass, useRemoveEmailTemplateFromClass } from 'api/Classes/Step7Communication/EmailTemplates'

interface AddTemplateToClassProps {
  openModal: boolean
  closeModal: React.Dispatch<React.SetStateAction<boolean>>
}

const AddTemplateToClass: React.FC<AddTemplateToClassProps> = ({
  openModal,
  closeModal,
}) => {
  const classData = creationClassStore(store => store.classData)
  const setClassData = creationClassStore(store => store.setClassData)
  const organizationId = myStore(store => store.organizationId)
  const [openTemplateModal, setOpenTemplateModal] = useState<boolean>(false)
  const [loaderId, setLoaderId] = useState<string | null>(null)
  const [templateData, setTemplateData] = useState<any>()

  const handleCancel = () => {
    closeModal(false)
  }
  
  const { mutate: createTemplate } = useCreateEmailTemplateForClass()
  const { mutate: editTemplate } = useEditEmailTemplateForClass()
  const { mutate: removeTemplate } = useRemoveEmailTemplateFromClass()

  const handleEditTemplate = (emailTemplate: any) => {
    setTemplateData(emailTemplate)
    setOpenTemplateModal(true)
  }

  const handleAddTemplate = () => {
    setTemplateData(null)
    setOpenTemplateModal(true)
  }

  const handleAddToClass = (
    templateId: string,
    operation: 'add' | 'remove',
  ) => {
    if (!classData) {
      console.error('Class data is not available')
      setLoaderId(null)
      return
    }
    
    setLoaderId(templateId)
    
    if (operation === 'remove') {
      removeTemplate(
        {
          classId: classData._id,
          templateId: templateId,
        },
        {
          onSuccess: () => {
            const updatedEmailTemplates = classData.emailTemplates?.filter(
              (template: any) => template._id !== templateId
            ) || []
            setClassData({ ...classData, emailTemplates: updatedEmailTemplates })
            setLoaderId(null)
          },
          onError: () => {
            setLoaderId(null)
          },
        },
      )
    } else {
      const payload: AddEmailTemplatesIntoTheClassPayload = {
        emailTemplate: {
          ...templateData,
          status: 'active',
        },
      }
      createTemplate(
        {
          payload,
          classId: classData._id,
        },
        {
          onSuccess: data => {
            const updatedEmailTemplates = [...(classData.emailTemplates || []), data]
            setClassData({ ...classData, emailTemplates: updatedEmailTemplates })
            setLoaderId(null)
          },
          onError: () => {
            setLoaderId(null)
          },
        },
      )
    }
  }

  return (
    <div>
      <Modal
        open={openModal}
        onCancel={handleCancel}
        className="confirmation-email"
        footer={false}
        width={700}
        centered
      >
        <div className="flex-center pt-20px justify-between ">
          <h2 className="w-600 text-18">Scheduled emails</h2>
          <img
            src={closeIcon}
            alt="close-button"
            onClick={handleCancel}
            className="close button pointer"
          />
        </div>
        <p>Set the email template and the trigger when it should be sent.</p>
        <div className="mt-20px h-25rem overflow-auto-y scroller">
          {classData?.emailTemplates?.length > 0 ? (
            <div>
              {classData.emailTemplates.map(template => {
                return (
                  <div key={template._id}>
                    <TemplateInfo
                      template={template}
                      loaderId={loaderId}
                      isClassTemplate={true}
                      handleAddToClass={handleAddToClass}
                      handleEditTemplate={handleEditTemplate}
                    />
                  </div>
                )
              })}
            </div>
          ) : (
            <div className="h-full flex align-center justify-center">
              <EmptyData message="No templates available" />
            </div>
          )}
        </div>
        <div className="mt-30px flex gap-20px justify-between align-center">
          <button className=" btn-secondary" onClick={handleCancel}>
            cancel
          </button>
          <button
            className="pointer flex align-center gap-16px simple-btn"
            onClick={handleAddTemplate}
          >
            <img src={plusBlue}></img> <p>Add New template</p>
          </button>
        </div>
      </Modal>

      {openTemplateModal && (
        <EmailTemplateModal
          openModal={openTemplateModal}
          closeModal={setOpenTemplateModal}
          organizationId={organizationId}
          referenceId={classData?._id || ''}
          reference="class"
          data={templateData}
        />
      )}
    </div>
  )
}

export default AddTemplateToClass
